import { orderBy, isEmpty, isDate, sumBy, reduce, groupBy } from 'lodash';

export function getCatQuizWrongResults(state) {
  if (isEmpty(state.quizWrongResults)) {
    return [];
  }

  const sortTargetName = 'updated_at';
  return orderBy(state.quizWrongResults, [sortTargetName], ['desc']) || [];
}

export function getCurrentScore(state) {
  return state.proficiencyHistory.current_score || 0;
}

export function getClAverageScore(state) {
  return state.proficiencyHistory.cl_average_score || 0;
}

export function getDomainsElements(state) {
  return state.domainsElements || [];
}

export function getSortDomainsElements(state, getters) {
  if (isEmpty(getters.getDomainsElements)) {
    return [];
  }

  const sortTargetName = 'answer_rate';
  return orderBy(getters.getDomainsElements, [sortTargetName], ['asc']);
}

export function getDomainsElementsLimit(state, getters) {
  if (isEmpty(getters.getDomainsElements)) {
    return [];
  }

  const maxDomainsElements = 4;
  return getters.getSortDomainsElements &&
    getters.getSortDomainsElements.slice(0, maxDomainsElements);
}

export function getHistoryScores(state) {
  const sortTargetName = 'updated_at';
  return orderBy(state.proficiencyHistory.history, [sortTargetName], ['desc']) || [];
}

export function getOrderCurrentScores(state, getters) {
  const sortTargetName = 'updated_at';
  const limitScore = 3;

  const defaultScore = {
    proficiency_score: 0,
    updated_at: '',
  };

  const todayScore = {
    proficiency_score: getters.getCurrentScore,
    updated_at: new Date(),
  };

  if (getters.getHistoryScores.length === 0) {
    return [
      defaultScore,
      todayScore,
    ];
  }

  const lastScore = getters.getHistoryScores[0];
  const lastScoreDate = new Date(new Date(lastScore.updated_at.slice(0, 10)).setHours(0, 0, 0, 0));
  const todayScoreDate = new Date(new Date().setHours(0, 0, 0, 0));

  if (lastScoreDate.getTime() === todayScoreDate.getTime()) {
    if (getters.getHistoryScores.length === 1) {
      return orderBy([defaultScore, todayScore], sortTargetName, ['asc']);
    }

    return orderBy([...getters.getHistoryScores.slice(1, 4), todayScore], sortTargetName, ['asc']);
  }
  return [...orderBy(getters.getHistoryScores.slice(0, limitScore), sortTargetName, ['asc']), todayScore];
}

export function getCurrentScoresData(state, getters) {
  return getters.getOrderCurrentScores.map(item => (
    (item.proficiency_score || 0)
  ));
}

export function getCurrentScoresDates(state, getters) {
  return getters.getOrderCurrentScores.map(item => (
    (item.updated_at || '')
  ));
}

export function getCurrentScoreDateLabels(state, getters) {
  return getters.getCurrentScoresDates.map((item) => {
    if (item === '') {
      return item;
    }

    const date = isDate(item) ? item : new Date(item.slice(0, 10));
    return `${(date.getMonth() + 1)}.${date.getDate()}`;
  });
}

export function getDomainConcepts(state) {
  return state.domainConcepts;
}

export function getQuizResultCaches(state) {
  return state.quizResultCaches || [];
}

export function getCatList(state) {
  return orderBy(state.catList, ['created_at'], ['asc']);
}

export function getUserRanking(state) {
  return state.userRanking;
}

export function getUserScoreCache(state, getters) {
  return getters.getUserRanking.score_cache || {};
}

export function getRankingScores(state) {
  return state.rankingScores;
}

export function getUserPoint(state, getters) {
  return getters.getUserRanking.point || 0;
}

export function getTotalPoint(state, getters) {
  return sumBy(getters.getRankingScores, 'point') || 0;
}

export function getTotalScore(state, getters) {
  return sumBy(getters.getRankingScores, 'value') || 0;
}

export function getUserExp(state, getters) {
  return getters.getUserScoreCache.total_value || 0;
}

export function getCatExp(state) {
  if (isEmpty(state.catExpHistories)) return 0;
  return sumBy(state.catExpHistories, 'exp');
}

export function getCatAdjustExp(state) {
  if (isEmpty(state.catExpHistories)) return 0;
  return sumBy(state.catExpHistories, 'adjust_exp');
}

export function getCatExpHistory(state, getters) {
  return {
    exp: getters.getCatExp,
    adjust_exp: getters.getCatAdjustExp,
  };
}

export function isEmptyFlightBoxRewardHistories(state) {
  return isEmpty(state.flightBoxRewardHistories);
}

export function flightBoxRewardHistories(state, getters) {
  if (getters.isEmptyFlightBoxRewardHistories) return [];
  const groupedRewardHistories = groupBy(state.flightBoxRewardHistories, 'flight_box_reward_type.name');

  const results = reduce(groupedRewardHistories, (acc, cur, key) => [
    ...acc,
    {
      reward_type_name: key,
      reward_count: cur.length,
    },
  ], []);

  return results;
}
